/**
 * file : Header.jsx
 * 설명 : 상단 바
 */

import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light fixed-top py-3" id="mainNav">
        <div className="container px-4 px-lg-5">
          <Link to="/" className="navbar-brand">WebSheet</Link>
          <button className="navbar-toggler navbar-toggler-right" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav ms-auto my-2 my-lg-0">
              {/* <li className="nav-item"><Link to="/Board" className="nav-link">게시판</Link></li> */}
              <li className="nav-item"><Link to="/Directions" className="nav-link">오시는 길</Link></li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  )
}   